import { animate } from 'animejs'

export const useAnimate = () => {
    /**
    * Run an animation with anime.js
    */
    const anime: typeof animate = (targets, params) => {
        if (import.meta.client) {
            return animate(targets, params)
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return null as any
    }

    return { anime }
}